import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { KdsStation } from '../../components/common/KdsStation';
import { Button } from '../../components/ui/button';
import { LanguageSwitcher } from '../../components/LanguageSwitcher';
import { ChefHat, LogOut, Sun, Moon, RefreshCw } from 'lucide-react';

export default function KitchenApp() {
  const { t } = useTranslation();
  const { user, logout, setUiLanguage } = useAuth();
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="flex h-dvh flex-col bg-background">
      <header className="flex h-16 items-center gap-3 border-b border-border bg-card px-4 md:px-6">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary">
          <ChefHat className="h-6 w-6 text-primary-foreground" />
        </div>
        <div className="min-w-0">
          <div className="font-display text-lg font-semibold leading-tight">{t('kitchen.title')}</div>
          <div className="truncate text-xs text-muted-foreground">{user?.name || t('kitchen.station')} · {t('kitchen.realtimeOrders')}</div>
        </div>
        <div className="ml-auto flex items-center gap-2">
          <span className="hidden items-center gap-1.5 text-sm text-muted-foreground sm:flex">
            <RefreshCw className="h-4 w-4 animate-spin" style={{ animationDuration: '3s' }} /> {t('kitchen.auto')}
          </span>
          <Button variant="outline" size="icon" className="h-11 w-11 rounded-xl" onClick={toggleTheme} aria-label={t('kitchen.toggleTheme')} data-testid="kitchen-theme-toggle">
            {theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
          </Button>
          <LanguageSwitcher variant="compact" onChange={(code) => setUiLanguage(code)} />
          <Button variant="outline" className="h-11 rounded-xl" onClick={logout} data-testid="kitchen-logout">
            <LogOut className="h-5 w-5 sm:mr-2" /> <span className="hidden sm:inline">{t('kitchen.logout')}</span>
          </Button>
        </div>
      </header>
      <main className="flex-1 overflow-auto p-4 md:p-6">
        <KdsStation station="cucina" emptyLabel={t('kitchen.emptyKitchen')} />
      </main>
    </div>
  );
}
